module.exports = __webpack_public_path__ + "img/pig.23879e2e.svg";